import { OrderSummaryLine } from '@buy/state/order-summary/order-summary'
import React, { FunctionComponent, useEffect } from 'react'
import { ConnectedBuyFormatCurrency } from '@buy/connectedComponents'
import { getPrice } from '@buy/utils/volume-components-helpers'
import { BillingPeriod } from '@common/constants'
import { isEmpty, isUndefined } from 'lodash-es'
import styles from '../../connectedComponents/OrderSummary/order-summary.module.css'
import { BillingTenureValue } from '../BillingPeriodSwitch'

interface BaseLineSummaryProps {
    baseLine: OrderSummaryLine
    planName: string
    shortDescription: string
    monthsText: string
    isAnnual: boolean
    hasAdditionalLines: boolean
    setSubTotal: (value: number) => void
    subTotal: number
    billingTenure: BillingTenureValue
}

export const BaseLineSummary: FunctionComponent<BaseLineSummaryProps> = ({
    baseLine,
    planName,
    monthsText,
    hasAdditionalLines = false,
    setSubTotal,
    subTotal,
    // shortDescription,
    billingTenure,
    isAnnual,
}) => {
    useEffect(() => {
        const planPriceIndex =
            isAnnual && isUndefined(billingTenure.leftOption) ? BillingPeriod.ANNUAL : billingTenure.leftOption!
        const price = getPrice(1, baseLine.allPrices[planPriceIndex]) * baseLine.multiplier * (isAnnual ? 12 : 1)
        setSubTotal(price)
    }, [baseLine, isAnnual, setSubTotal, billingTenure])

    return (
        <>
            {!isEmpty(baseLine.key) && (
                <div className={styles.section}>
                    <div className={styles.row} data-qat="plan-summary">
                        <span className={styles['item-title']} data-qat="line-item-name">
                            {planName}
                        </span>
                        <span className={styles.item} data-qat="line-item-subtotal">
                            <ConnectedBuyFormatCurrency value={subTotal} />
                        </span>
                    </div>
                    {/* {!isEmpty(shortDescription) && (
                        <div className={styles.row}>
                            <span className={styles.small}>{`${shortDescription}`}</span>
                        </div>
                    )} */}
                    <div className={styles.row}>
                        <span className={styles.small}>
                            <ConnectedBuyFormatCurrency
                                value={getPrice(
                                    1,
                                    baseLine.allPrices[
                                        isAnnual && isUndefined(billingTenure.leftOption)
                                            ? BillingPeriod.ANNUAL
                                            : billingTenure.leftOption!
                                    ]
                                )}
                            />
                            &nbsp;x&nbsp;
                            {!hasAdditionalLines && baseLine.unit && (
                                <>
                                    {`${baseLine.quantity} ${baseLine.unit}`}
                                    &nbsp;x&nbsp;
                                </>
                            )}
                            <span className={styles['item-sub-line']}>
                                {isAnnual ? 12 : 1} {monthsText}
                            </span>
                        </span>
                    </div>
                </div>
            )}
        </>
    )
}
